export default {
  ru: {
    label: 'Email',
    placeholder: 'Введите ваш email',
    invalid: 'Невалидный E-mail',
    error: 'Email введен неверно',
  },
  en: {
    // en
  },
};
